export const createAbortError = () => new DOMException('', 'AbortError');
//# sourceMappingURL=abort-error.js.map